import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyAppointmentReminders = lazy(() => import('./svg-components/appointment-reminders'));

const AppointmentReminders = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyAppointmentReminders {...rest} />
  </Suspense>
);

export default AppointmentReminders;
